import styled, { css } from 'styled-components/macro';

export const Container = styled.div`
  ${({ enabled }: any) =>
    enabled &&
    css`
      filter: blur(4px);
    `}
`;
